import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { NodeHeader } from 'modules/job_catalog/components/NodeHeader'
import CategoriesTabs from 'modules/job_catalog/components/TreeNodeAttributes/CategoriesTabs'
import CompetenciesAttributes from 'modules/job_catalog/components/TreeNodeAttributes/CompetenciesAttributes'
import OverviewAttributes from 'modules/job_catalog/components/TreeNodeAttributes/OverviewAttributes'
import WorkingConditionsAttributes from 'modules/job_catalog/components/TreeNodeAttributes/WorkingConditionsAttributes'
import { useTreeNode } from 'modules/job_catalog/hooks/useTreeNode'
import {
  DEFAULT_CATEGORIES,
  getParentChain,
  maximizeClickPath,
  normalizeNodeType,
} from 'modules/job_catalog/lib/nodesUtils'

const TreeNodePage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { id } = useParams<{ id: string }>()

  const {
    nodeId,
    nodeName,
    nodeType,
    currentNode,
    currentAttributes,
    salaryRangeValue,
    childrenInformation,
    activeTab,
    setActiveTab,
  } = useTreeNode(id)

  if (!nodeId || !nodeType || !currentNode) return null

  const handleMaximizeClick = () => {
    if (!currentNode || !id) return

    navigate(
      maximizeClickPath(
        getParentChain(currentNode),
        normalizeNodeType(currentNode.type),
        id,
        navigation,
        currentNode.type
      )
    )
  }

  return (
    <Sidepanel
      onClose={() => navigate(navigation.employees.jobCatalog.overview.fullPath())}
      open
      width="wide"
      title={nodeName}
      boxPadding={false}
      options={[
        {
          title: i18n.t('common.edit'),
          icon: 'pencil',
          onClick: handleMaximizeClick,
        },
      ]}
    >
      <NodeHeader
        name={currentNode.name}
        description={currentNode.description || ''}
        type={currentNode.type}
        childrens={currentNode.children}
        salaryRangeValue={salaryRangeValue}
        canEditRole={false}
        currentNode={currentNode}
        isMaximized
      />
      <Box gap="s16" height="full-view-height">
        <CategoriesTabs
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          nodeType={normalizeNodeType(nodeType)}
        />
        <Box height="full">
          {activeTab === DEFAULT_CATEGORIES.COMPETENCIES && (
            <CompetenciesAttributes
              items={currentAttributes.filter((item) => item.type === activeTab)}
            />
          )}
          {activeTab === DEFAULT_CATEGORIES.WORKING_CONDITIONS && (
            <WorkingConditionsAttributes
              items={currentAttributes.filter((item) => item.type === activeTab)}
            />
          )}
          {activeTab === DEFAULT_CATEGORIES.OVERVIEW && (
            <OverviewAttributes
              currentNode={currentNode}
              childrenInformation={childrenInformation}
            />
          )}
        </Box>
      </Box>
    </Sidepanel>
  )
}

export default TreeNodePage
